var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-sm btn-default btn-icon ml-2",attrs:{"href":_vm.href,"target":_vm.targetBlank ? '_blank' : '_self',"data-toggle":"tooltip","data-theme":"dark","title":_vm.title},on:{"click":_vm.clicked}},[_c('i',{class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }